import styles from './ProofBar.module.scss';

export interface ProofBarItem {
  value: string;
  label: string;
}

interface ProofBarProps {
  items: ProofBarItem[];
}

/**
 * Renders a row of quantified proof points (e.g. case study metrics).
 * Renders nothing when `items` is empty, so pages can wire it up now and
 * have it appear automatically once proof exists -- no follow-up refactor.
 */
const ProofBar = ({ items }: ProofBarProps) => {
  if (items.length === 0) return null;

  return (
    <div className={styles.proofBar}>
      {items.map((item, index) => (
        <div className={styles.proofItem} key={`${item.value}-${index}`}>
          <span className={styles.value}>{item.value}</span>
          <span className={styles.label}>{item.label}</span>
        </div>
      ))}
    </div>
  );
};

export default ProofBar;
